import TextEllipsis from "./TextEllipsis";
import ViewNoteModal from "./viewNoteModal";
import { useState } from "react";
const inputProps = {
  value: "",
  maxLength: 1000,
  isExpend: true,
  readonly: "readonly",
  className: "ReasonInput",
  iconClassName: "expendIcon",
  disabled: true,
  expendTextAreaClassName: "returnReasonDetail",
  isScrollExpend: true,
  isShowExpendIcon: false,
  isExpendNote: true,
  defaultExpend: true,
};

const ViewNoteHyperLinkModal = ({ value }: any) => {
  const [visible, setVisible] = useState(false);
  inputProps.value = value;

  const toggleButtonVisible = (_: any, isEllipsis: any) => {
    if (isEllipsis !== undefined && !isEllipsis) return;
    setVisible((p) => !p);
  };

  return (
    <>
      <TextEllipsis onClick={toggleButtonVisible}>{value}</TextEllipsis>
      <ViewNoteModal
        testid="view-note-modal"
        isReasonDetailModalOpen={visible}
        handleReturnReasonDetail={toggleButtonVisible}
        inputProps={inputProps}
      />
    </>
  );
};

export default ViewNoteHyperLinkModal;
